import * as React from 'react';
import { useSelector } from 'react-redux';

import { Phones } from '../../../components/AuthorCallReasons/parts/Phones';
import { getPhones } from '../../../selectors';
import { formatNumber, getPhoneLink } from '../../../utils/phone';

export const PhonesOpened = () => {
  const phones = useSelector(getPhones);

  const formattedPhones = React.useMemo(
    () =>
      phones.map(phone => ({
        number: formatNumber(phone),
        link: getPhoneLink(phone),
      })),
    [phones],
  );

  if (!phones.length || phones.some(phone => !phone.countryCode || !phone.number)) {
    return null;
  }

  return <Phones size="xs" phones={formattedPhones} />;
};
